import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onBeforeUnmount, onMounted, ref } from "vue";

// Chispas/brasas que suben como de una fragua
interface Ember {
  x: number;
  y: number;
  r: number;
  vy: number;
  vx: number;
  life: number;
  max: number;
  hue: number;
  phase: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EmberCanvas',
  props: { density: { type: Number, default: 90 } },
  setup(__props) {

const props = __props;



const canvas = ref<HTMLCanvasElement | null>(null);
let ctx: CanvasRenderingContext2D | null = null;
let embers: Ember[] = [];
let frame = 0;
let width = 0;
let height = 0;
let visible = true;
let observer: IntersectionObserver | null = null;

const spawn = (initial = false): Ember => {
  const max = 220 + Math.random() * 380;
  return {
    x: Math.random() * width,
    y: initial ? Math.random() * height : height + 10,
    r: 0.6 + Math.random() * 2.2,
    vy: 0.35 + Math.random() * 1.2,
    vx: (Math.random() - 0.5) * 0.4,
    life: initial ? Math.random() * max : 0,
    max,
    hue: 18 + Math.random() * 28,
    phase: Math.random() * Math.PI * 2,
  };
};

const resize = () => {
  const el = canvas.value;
  if (!el || !ctx) return;
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  width = el.clientWidth;
  height = el.clientHeight;
  el.width = width * dpr;
  el.height = height * dpr;
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  const count = Math.round((props.density * width) / 1440) + 25;
  embers = Array.from({ length: count }, () => spawn(true));
};

const tick = () => {
  frame = requestAnimationFrame(tick);
  if (!ctx || !visible) return;
  ctx.clearRect(0, 0, width, height);
  ctx.globalCompositeOperation = "lighter";
  for (let i = 0; i < embers.length; i++) {
    const e = embers[i];
    e.life++;
    e.phase += 0.03;
    e.y -= e.vy;
    e.x += e.vx + Math.sin(e.phase) * 0.35;
    const t = e.life / e.max;
    if (t >= 1 || e.y < -10) {
      embers[i] = spawn();
      continue;
    }
    const alpha = Math.sin(Math.PI * t) * (0.6 + Math.sin(e.phase * 3) * 0.25);
    const glow = e.r * 6;
    const g = ctx.createRadialGradient(e.x, e.y, 0, e.x, e.y, glow);
    g.addColorStop(0, `hsla(${e.hue + 15}, 100%, 75%, ${alpha})`);
    g.addColorStop(0.25, `hsla(${e.hue}, 100%, 55%, ${alpha * 0.5})`);
    g.addColorStop(1, `hsla(${e.hue}, 100%, 40%, 0)`);
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.arc(e.x, e.y, glow, 0, Math.PI * 2);
    ctx.fill();
  }
};

onMounted(() => {
  if (!canvas.value) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  ctx = canvas.value.getContext("2d");
  resize();
  window.addEventListener("resize", resize);
  observer = new IntersectionObserver(([entry]) => {
    visible = entry.isIntersecting;
  });
  observer.observe(canvas.value);
  tick();
});

onBeforeUnmount(() => {
  cancelAnimationFrame(frame);
  window.removeEventListener("resize", resize);
  observer?.disconnect();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("canvas", {
    ref_key: "canvas",
    ref: canvas,
    class: "pointer-events-none absolute inset-0 h-full w-full"
  }, null, 512))
}
}

})